var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.643 75.315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.643-66.064c0,3.9,3.263,7.8,8.146,11.03a3.554,3.554,0,0,0,1.517.724,3.463,3.463,0,0,0,1.505-.724c4.895-3.229,8.158-7.135,8.158-11.03,0-3.78-2.643-6.251-5.7-6.251a4.666,4.666,0,0,0-3.964,1.85,4.666,4.666,0,0,0-3.964-1.85C11.285-72.314,8.643-69.844,8.643-66.064ZM11.8-66.1a3.026,3.026,0,0,1,3.056-3.194,3.08,3.08,0,0,1,2.62,1.448c.264.379.506.563.827.563s.54-.2.816-.563a3.15,3.15,0,0,1,2.631-1.448A3.026,3.026,0,0,1,24.809-66.1c0,2.6-2.539,5.791-6.388,8.353a.186.186,0,0,1-.115.046.186.186,0,0,1-.115-.046C14.33-60.308,11.8-63.5,11.8-66.1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heartOutline.1bf79a9c22a2935e50943739ffea6163.svg";
export { ForwardRef as ReactComponent };